import React from 'react'
import { Modal } from '@centra/centra-ui'

import SingleTask from 'components/SingleTask'
import { useStyles } from './TaskModal.style'
import { useSelector } from 'react-redux'
import { useTitle } from 'hooks/useTitle'

interface ITaskModal {
  isTaskModalCreating: boolean
  open: boolean
  onClose: () => void
}

const TaskModal = (props: ITaskModal) => {
  const { open, onClose, isTaskModalCreating } = props
  const classes = useStyles()
  const { taskLoading, task, userName } = useSelector(({ taskManager, profile }) => ({
    ...taskManager,
    userName: `${profile.profile?.firstName} ${profile.profile?.lastName}`,
  }))

  const clientName = !isTaskModalCreating && task?.client.name ? task?.client.name : userName

  if (isTaskModalCreating) {
    useTitle('createTask', ['Создание задачи', clientName])
  } else {
    useTitle('task', [String(task?.id || ''), task?.name || '', clientName])
  }

  return (
    <Modal open={open} onClose={onClose}>
      <div className={classes.paper}>
        <SingleTask onClose={onClose} loading={taskLoading} isTaskModalCreating={isTaskModalCreating} />
      </div>
    </Modal>
  )
}

export default TaskModal
